import React, { useReducer } from 'react'
import NotesReducer from './notesReducer'
import NotesContext from './notesContext'
import { apiCall } from '../../common/api'
import { response } from '../common'

import { CLEAR_RESPONSE, RESPONSE_STATUS, GET_ALL_NOTES } from './notesTypes'

const NotesState = (props) => {
    const initialState = {
        all_notes: null,
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(NotesReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllNotes = async (formData, fromName) => {
        const from = 'notesAction'
        try {
            const [res] = await Promise.all([
                apiCall('post', from, formData, '', 'notes'),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_NOTES,
                    payload: {
                        all_records: res.data.data.responseData.data
                            ? res.data.data.responseData.data
                            : [],
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromName ? fromName : from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }
    const notesManage = async (formData, fromName) => {
        try {
            const from = 'notesAction'
            const [res] = await Promise.all([
                apiCall('post', from, formData, '', 'notes'),
            ])
            resp.commonResponse(res.data, fromName ? fromName : from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }
    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <NotesContext.Provider
            value={{
                all_notes: state.all_notes,
                responseStatus: state.responseStatus,
                getAllNotes,
                notesManage,
                clearResponse,
            }}
        >
            {props.children}
        </NotesContext.Provider>
    )
}

export default NotesState
